<template>
    <div class="mElaboration-container" v-observe-visibility="startAnimate">
        <div class="line" id="neonShadow"></div>
        <div class="mElaborationContent-container" :class="{onlySafari: isSafari}">
            <div class="bgOpacity">
                <div style="display: flex;">
                    <img class="processOf" :src="processOf" alt="Proceso de elaboración de la NUEVA Tecate 0.0">
                    <img class="elaborationContainer" :src="elaborationContainer" alt="Banner elaboración">
                    <img class="elaborationText" :src="elaborationText" alt="Tecate 0.0 utiliza un proceso nuevo e innovador en México, que logra elaborar la cerveza con todo el sabor y sin producir alcohol, haciendo de este un proceso más rápido">
                    <div>
                        <img class="tanksImg" :class="{animate: animate}" :src="tanksImg" alt="Tanques- El proceso de Tecate 0.0 gasta menos agua, vapor y electricidad haciéndola mas amigable con el medio ambiente">
                    </div>
                </div>
                <div class="stepsElaboration">
                    <div class="stepsElaboration1">
                        <div class="textsElaboration textInfo1" :class="{animate: animate}">
                                <!-- <img class="textInfo1" :class="{animate: animate}" :src="ingredients" alt="Ingredientes: se agregan los ingredientes de una cerveza: malta, almidón de maíz, agua y levadura"> -->
                                <span style="position: relative;">
                                    <div class="textsElaboration-numberContainer1">
                                        <p class="textsElaboration-Number">1</p>
                                    </div>
                                </span>
                                <p class="textsElaboration-cardTittle">INGREDIENTES</p>
                                <p class="textsElaboration-cardInfo">SE AGREGAN LOS INGREDIENTES DE UNA CERVEZA: MALTA, ALMIDÓN DE MAÍZ, AGUA Y LEVADURA.</p>
                                <div class="triengule-Elaboration1"></div>  
                        </div>
                        <div class="textsElaboration textInfo2" :class="{animate: animate}">
                            <!-- <img class="textInfo2" :class="{animate: animate}" :src="cooking" alt="Cocción: se produce Tecate original pero a una temperatura más baja para no producir alcohol, este proceso produce la cosistencia de una cerveza y su aroma pero sin alcohol"> -->
                            <span style="position: relative;">
                                <div class="textsElaboration-numberContainer2">
                                    <p class="textsElaboration-Number">2</p>
                                </div>
                            </span>
                            <p class="textsElaboration-cardTittle">COCCIÓN</p>
                            <p class="textsElaboration-cardInfo">SE PRODUCE TECATE ORIGINAL PERO A UNA TEMPERATURA MÁS BAJA PARA NO PRODUCIR ALCOHOL, ESTE PROCESO PRODUCE LA CONSISTENCIA DE UNA CERVEZA Y SU AROMA PERO SIN ALCOHOL.</p>
                            <div class="triengule-Elaboration2"></div>
                        </div>
                        <div class="textsElaboration textInfo3" :class="{animate: animate}">
                            <!-- <img class="textInfo3" :class="{animate: animate}" :src="secondAction" alt="2da Cocción: nuestro maestro cervecero la armoniza y la embotella"> -->
                            <span style="position: relative;">
                                <div class="textsElaboration-numberContainer3">
                                    <p class="textsElaboration-Number">3</p>
                                </div>
                            </span>
                            <p class="textsElaboration-cardTittle">2da COCCIÓN</p>
                            <p class="textsElaboration-cardInfo">NUESTRO MAESTRO CERVECERO  LA ARMONIZA Y LA EMBOTELLA.</p>
                            <div class="triengule-Elaboration3"></div>
                        </div>
                        <div class="textsElaboration textInfo4" :class="{animate: animate}">
                            <!-- <img class="textInfo4" :class="{animate: animate}" :src="smell" alt="Aroma: llega a ti"> -->
                            <span style="position: relative;">
                                <div class="textsElaboration-numberContainer4">
                                    <p class="textsElaboration-Number">4</p>
                                </div>
                            </span>
                            <p class="textsElaboration-cardTittle">AROMA</p>
                            <p class="textsElaboration-cardInfo">LLEGA A TI.</p>
                            <div class="triengule-Elaboration4"></div>
                        </div>
                    </div>
                    <div>
                        <img class="bottleEP" :src="bottleEP" :class="{onlySafari: isSafari}" alt="Botella Tecate 0.0">
                    </div>
                    <div class="newText" :class="{animate: animate, onlySafari: isSafari}">
                        <p class="subNewText1">¡Y LISTO!</p>
                        <p class="subNewText2">
                            ASÍ ES COMO NACE<br>
                            NUESTRA NUEVA TECATE<br>
                        </p>
                        <p class="subNewText3">
                            <b>CON UN GRADO DE</b><br>
                            <b>ALCOHOL DE 0.0%</b>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import tanksImg from '@/assets/tkt-elaboration/IMG-Tanques2.png';
import processOf from '@/assets/tkt-elaboration/PROCESO-DE.png';
import elaborationContainer from '@/assets/tkt-elaboration/ELABORACION-BACK.png';
import elaborationText from '@/assets/tkt-elaboration/ELABORACION-PALABRA.png';
import ingredients from '@/assets/tkt-elaboration/INGREDIENTES.png';
import cooking from '@/assets/tkt-elaboration/Coccion.png';
import secondAction from '@/assets/tkt-elaboration/2DA-COCCION.png';
import smell from '@/assets/tkt-elaboration/Aroma.png';
import bottleEP from '@/assets/tkt-elaboration/Botella-Proceso-Elaboracion.png';
import opacityImg from '@/assets/tkt-elaboration/BACK-PROCESO-ELABORACION-OPACIDAD.png';
import { mapGetters } from "vuex";
import Bowser from "bowser";
import tagFunctions from '@/utils/tagFunctions.js'

export default {
    name: "Elaboration",
    data() {
        return {
            animate: false,
            isSafari: false,
            opacityImg,
            tanksImg,
            processOf,
            elaborationContainer,
            elaborationText,
            ingredients,
            cooking,
            secondAction,
            smell,
            bottleEP,
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if (isVisible) {
                this.animate = true
            }
        },
        retailerClick(storeName) {
            tagFunctions.evib2cOutboundlinkPush(storeName)
        },
    },
    components: {},
    mounted() {
    },
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName() == 'Safari') {
            this.isSafari = true
        }
    }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Elaboration.scss";
</style>